import React from "react";

const Card = ({ image, onClick }) => {
  return (
    <div className="card" onClick={onClick}>
      <img src={image} alt="Memory Card" />
    </div>
  );
};

export default Card;
